import React from "react";
import { connect } from "react-redux";

import {
  doGetAllGroups,
  doCreateGroup,
  doUpdateGroup,
  doDeleteGroup,
  doUpdateGroupInviteEmail,
  doUpdateGroupDisInviteEmail,
  doGetGroupInviteEmails,
  doOffGroupInviteEmails,
  doGroupAcceptInvite,
  doGroupGetDetailCode,
} from "../stores/thunk";
import { selectAllGroups } from "../stores/slice";

export default Component => {
  class Container extends React.Component {
    render() {
      return <Component {...this.props} />;
    }
  }
  function mapStateToProps(state) {
    return {
      isFetching: state.group.isFetching,
      isSucceeded: state.group.status === "succeeded",
      metadata: state.group.metadata,
      invite: state.group.invite,
      detailCode: state.group.detailCode,
      status: state.group.status,
      acceptedInvite: state.group.acceptedInvite,
      groups: selectAllGroups(state),
    };
  }

  return connect(mapStateToProps, {
    doGetAllGroups,
    doCreateGroup,
    doUpdateGroup,
    doDeleteGroup,
    doDeleteGroup,
    doUpdateGroupInviteEmail,
    doUpdateGroupDisInviteEmail,
    doGetGroupInviteEmails,
    doOffGroupInviteEmails,
    doGroupAcceptInvite,
    doGroupGetDetailCode,
  })(Container);
};
